// extracted by mini-css-extract-plugin
module.exports = {"customPreloader":"CustomPreloader_customPreloader__opYL6","item-rotate":"CustomPreloader_item-rotate__FVF_X"};